<template><AdminServiceList kind="accommodation" /></template>
<script setup>import AdminServiceList from "@/components/catalog/AdminServiceList.vue";</script>
